import { mobile, tablet } from "components/templates/Breakpoints";
import { types } from "react-bricks/frontend";
import styled from "styled-components";

export interface MapProps {
  locationUrl: string;
}

const Map: types.Brick<MapProps> = ({ locationUrl }) => {
  return (
    <MapContainer>
      {locationUrl ? (
        <iframe
          src={locationUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
      ) : (
        <Placeholder>Set a Google Maps embed URL in the side edit panel.</Placeholder>
      )}
    </MapContainer>
  );
};

Map.schema = {
  name: "map-section",
  label: "Google Map",
  category: "Map",
  getDefaultProps: () => ({
    locationUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.3696542540984!2d-0.0887182!3d51.5247795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761ae1f4fee93f%3A0x226af7da0b39d5e!2sYuLife!5e0!3m2!1sen!2suk!4v1748616416113!5m2!1sen!2suk",
  }),
  sideEditProps: [
    {
      name: "locationUrl",
      label: "Google Maps Embed URL",
      type: types.SideEditPropType.Text,
    },
  ],
};

const MapContainer = styled.div`
  width: 100%;
  max-width: 64rem;
  height: 37rem;
  border-radius: 1rem;
  overflow: hidden;

  ${tablet} {
    height: 24rem;
  }

  ${mobile} {
    height: 11rem;
  }
`;

const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eee;
  color: #666;
  height: 100%;
  font-style: italic;
`;

export default Map;
